import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=51ec6e1c&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=51ec6e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ec6e1c",
  null
  
)

export default component.exports